// Scheduled dates belong to each interview's timezone, independent of creation time.
export const scheduledDateKey = (interview) => {
  const value = String(interview?.interviewDate || "");
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/);
  if (!match) return "";
  const [, year, month, day] = match.map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  )
    return "";
  return value.slice(0, 10);
};
export function todayInTimeZone(timeZone, now = new Date()) {
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  let parts;
  try {
    parts = new Intl.DateTimeFormat("en-US", {
      ...options,
      ...(timeZone ? { timeZone } : {}),
    }).formatToParts(now);
  } catch {
    parts = new Intl.DateTimeFormat("en-US", options).formatToParts(now);
  }
  const values = Object.fromEntries(
    parts.map((part) => [part.type, part.value]),
  );
  return `${values.year}-${values.month}-${values.day}`;
}
export function matchesPipelineTab(interview, tab, now = new Date()) {
  const stage = interview.job_application_status;
  if (tab === "ongoing") return stage === "In Progress";
  if (tab === "completed") return stage === "Completed";
  if (tab === "all") return true;
  if (!["Scheduled", "Invite Sent"].includes(stage)) return false;
  const date = scheduledDateKey(interview);
  if (!date) return false;
  const today = todayInTimeZone(interview.interviewTimezone, now);
  return tab === "today"
    ? date === today
    : tab === "upcoming"
      ? date > today
      : false;
}
export function selectionStatus(interview) {
  if (interview.selectionStatus)
    return String(interview.selectionStatus).toUpperCase();
  if (String(interview.candidate_selection_status).toLowerCase() === "pass")
    return "SHORTLISTED";
  if (String(interview.candidate_selection_status).toLowerCase() === "fail")
    return "REJECTED";
  return "PENDING";
}
